import React, { FC, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { IconButtonWrapper } from 'components/ui';
import { hideNotification } from 'modules/app/store/actions';
import { useDispatch } from 'react-redux';
import { t } from 'utils';
import styles from './Notification.module.scss';
import { appService } from 'modules';

export interface INotification {
  title: string;
  className?: string;
  hasCloseButton?: boolean;
  hasDontShowButton?: string;
}

const Notification: FC<INotification> = (props) => {
  const { title, children, className, hasCloseButton, hasDontShowButton } = props;
  const dispatch = useDispatch();
  const [isHide, setIsHide] = useState(false);
  const rootClassName = classNames(styles.root, className);

  useEffect(() => {
    if (hasDontShowButton) {
      const notificationState = appService.getNotification(hasDontShowButton);
      if (notificationState) setIsHide(true);
    }
  }, [hasDontShowButton]);

  const handleCloseButton = useCallback(() => {
    setIsHide(true);
  }, []);

  const handleHideNotification = useCallback(() => {
    if (!hasDontShowButton) return;
    dispatch(hideNotification(hasDontShowButton));
    setIsHide(true);
  }, [dispatch, hasDontShowButton]);

  if (isHide) return null;

  return isHide ? null : (
    <div className={rootClassName}>
      <p className={styles.header}>
        <span className='fas fa-lightbulb' />
        <span className={styles.title}>{t(title)}</span>
        {hasCloseButton && (
          <IconButtonWrapper
            onClick={handleCloseButton}
            className={styles.closeButton}
            icon='times'
          />
        )}
      </p>
      {children && <div className={styles.text}>{children}</div>}
      {hasDontShowButton && (
        <IconButtonWrapper onClick={handleHideNotification} className={styles.hideButton}>
          {t('dont.show.this.box.anymore')}
        </IconButtonWrapper>
      )}
    </div>
  );
};

export default Notification;
